<template>
	<div class="contact-us">

		<section class="banner">
			<div class="img">
				<img :src="`${publicPath}images/banner-contact-us.jpg`">
			</div>
			<div class="container">
				<h1>{{ $t("contactUs") }}</h1>
			</div>
		</section>

		<!-- <section class="banner">
			<div class="container">
				<h1>Contact <span>us</span></h1>
			</div>
		</section> -->

		<section class="contact-methods">
			<div class="container">
				<div class="method">
					<img :src="`${publicPath}images/phone.png`" style="width: 100%; max-width: 78px; margin: auto; display: block;">
					<span><strong>{{ $t('contactUsPhone') }}</strong></span>
					<span><a href="tel:+85228699981">(852) 2869 9981</a><br /><a href="tel:+85298128800">(852) 9812 8800</a></span>
				</div>
				<div class="method">
					<img :src="`${publicPath}images/fax.png`" style="width: 100%; max-width: 82px; margin: auto; display: block;">
					<span><strong>{{ $t('contactUsFax') }}</strong></span>
					<span>(852) 2869 9971</span>
				</div>
				<div class="method">
					<img :src="`${publicPath}images/email.png`" style="width: 100%; max-width: 72px; margin: auto; display: block;">
					<span><strong>{{ $t('contactUsEmail') }}</strong></span>
					<span><a href="mailto:gracemedhk@gmail.com">gracemedhk@gmail.com</a></span>
				</div>
			</div>
		</section>

		<section class="working-hour">
			<div class="container">
				<img :src="`${publicPath}images/timetable.png`" class="timetable desktop">
				<img :src="`${publicPath}images/m/mob_contact_2.jpg`" class="mobile">
				<div class="remarks desktop">
					<div class="remark">
						<img :src="`${publicPath}images/icon_star.png`" class="icon-star"> 公眾假期全日休息 Public holiday closed
					</div>
					<div class="remark">
						<img :src="`${publicPath}images/icon_star.png`" class="icon-star"> 敬請預約 By Appointment
					</div>
				</div>
			</div>
		</section>

		<section class="location">
			<div class="address">
				<img :src="`${publicPath}images/location.png`">
				<span><strong>{{ $t('contactUsLocation') }}</strong></span>
				<a href="https://maps.google.com/maps?ll=22.28224,114.156599&z=17&t=m&hl=en&gl=HK&mapclient=embed&cid=1136570562305234033" target="_blank"><span v-html="$t('contactUsAddress')" style="text-align: center;"></span></a>
			</div>
			<div class="gmap">
				<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3691.891329574427!2d114.15488238304413!3d22.282105961530473!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3404014f04341065%3A0xfc5e8e7945e9471!2zR3JhY2VNZWQg6Kqg5oGp6Yar55mC!5e0!3m2!1sen!2shk!4v1566697696725!5m2!1sen!2shk" width="100%" height="615" frameborder="0" style="border:0;" allowfullscreen=""></iframe>
				<!-- <iframe src="https://www.google.com/maps/d/embed?mid=1FKf89d9HNUHjoPC3u2GPIM8DL5CHF4S2&hl=en" width="100%" height="615" frameborder="0" style="border:0; margin-top: -150px;"></iframe> -->
			</div>
		</section>

		<footer>
			<div class="container">
				<div class="copyright">
					Copyright &copy; 2019 GraceMed. All Rights Reserved.
				</div>
			</div>
		</footer>
	</div>
</template>

<script>
export default {
	name: 'contactus',
	components: {

	},
	data () {
		return {
			publicPath: process.env.BASE_URL,
			mobileNav: false
		}
	},
	methods: {
		toggleMobileNav() {
			this.mobileNav = !this.mobileNav
		}
	}
}
</script>

<style>
/*.contact-us .banner {
	width: 100%;
	max-width: 100%;
	background: url(/images/banner-contact-us.jpg) left top no-repeat;
	background-size: cover;
}*/

.contact-us .banner .img {
	position: relative;	
}

.contact-us .banner img {
	width: 100%;
	max-width: 100%;
}

.contact-methods {
	margin: 140px auto;
}

.contact-methods .container {
	display: flex;
	flex-direction: row;
	justify-content: center;
}

.contact-methods .method {
	margin: 0 75px;
	font-size: 1.5em;
}

.method span {
	display: block;
	margin: 25px 0;
	text-align: center;
}

.method a {
	text-decoration: none;
	color: #75787b;
}

.working-hour .timetable {
	width: 100%;
	max-width: 728px;
	margin: auto;
	display: block;
}

.working-hour .remarks {
	max-width: 728px;
	margin: auto;
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
}

.remarks .remark {
	width: 50%;
	text-align: left;
}

.remarks .icon-star {
	width: 100%;
	max-width: 21px;
	vertical-align: bottom;
}

.location {
	height: 465px;
	display: block;
	display: flex;
	flex-direction: row;
	margin-top: 135px;
}

.location .address {
	width: 40%;
	background: #f5f0ec;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	height: 465px;
}

.location .address img {
	max-width: 108px;
}

.location .address span {
	margin: 30px 0;
	font-size: 1.2em;
	line-height: 1.6em;
}

.location .address a {
	text-decoration: none;
	color: #75787b;
}

.location .gmap {
	width: 60%;
	height: 465px;
	overflow: hidden;
}

.contact-us span strong {
	font-family: "Times New Roman", Times, serif;
	color: #85745f;
	font-size: 1.6em;
	font-weight: 400;
}

.zh .contact-us span strong {
	font-family: 'Raleway', 'Avenir', Helvetica, Arial, sans-serif;
}

@media handheld,only screen and (max-width: 800px) {
	.banner h1 {
		position: relative;
		color: #e39200;
		font-size: 2em;
		text-align: center;
		padding: 20px 0;
		margin: 0;
	}

	.contact-methods {
		margin: 50px auto;
	}

	.contact-methods .container {
		flex-direction: column;
	}

	.contact-methods .method {
		text-align: center;
		font-size: 1.2em;
		margin: 20px auto;
	}

	.method span {
		margin: 10px auto;
	}

	.working-hour .timetable {
		display: none;
	}

	.working-hour img {
		width: 100%;
		max-width: 500px;
		margin: auto;
	}

	.working-hour .remarks {
		display: none;
	}

	.location {
		flex-direction: column;
		margin-top: 50px;
		height: auto;
	}

	.location .address {
		width: 100%;
		padding: 40px 0 20px 0;
		height: auto;
	}

	.location .gmap {
		width: 100%;
	}
}
</style>